export const RIGID_PAGE_ASIDE_MAX_WIDTH = '520px'
export const RIGID_PAGE_MAX_WIDTH = '1366px'
